import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../Services/auth.service';
import { HubCard, SectionHub } from './section-hub.config';

/**
 * Generic section-hub landing page (Phase-2 nav).
 *
 * Renders a Canva-style grid of cards/links for a rail section that is presented as a
 * hub rather than a drawer (e.g. Selling, Marketing). The card set comes from the
 * route's `data.hub` (a SectionHub from section-hub.config.ts), so one component serves
 * every hub and the data stays the single source of truth.
 */
@Component({
    selector: 'ds-section-hub',
    templateUrl: './ds-section-hub.component.html',
    styleUrls: ['./ds-section-hub.component.css'],
    standalone: false
})
export class DsSectionHubComponent implements OnInit, OnDestroy {
    public title = '';
    public subtitle = '';
    public icon = '';
    public cards: HubCard[] = [];

    private destroy$ = new Subject<void>();

    constructor(private route: ActivatedRoute, private auth: AuthService) { }

    public ngOnInit(): void {
        // Subscribe (not snapshot) so navigating hub→hub on the reused component updates.
        this.route.data.pipe(takeUntil(this.destroy$)).subscribe(d => {
            const hub = d['hub'] as SectionHub | undefined;
            this.title = hub?.title ?? '';
            this.subtitle = hub?.subtitle ?? '';
            this.icon = hub?.icon ?? '';
            this.cards = (hub?.cards ?? []).map(c => ({ ...c, link: this.resolveLink(c.link) }));
        });
    }

    /** Resolve a ':me' link segment to the current artist's username (for the public-profile link). */
    private resolveLink(link: any[]): any[] {
        const me = this.auth.getUserName() || this.auth.getUserId();
        return link.map(s => (s === ':me' ? me : s));
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
